import React from 'react'
import { useQueryWithHandler } from '@/hooks/useQueryWithHandler'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import { IPermissionProps } from '@/types/shared'
import { getBusinessSummary } from '@/modules/Business/services'
import useAuthStore from '@/stores/useAuthStore'
import ApprovedIcons from '@/icons/ApprovedIcons'
import PendingIcons from '@/icons/PendingIcons'
import RejectedIcons from '@/icons/RejectedIcons'
import { BusinessSummary } from '@/modules/Business/types/response'

import { QUERY_KEYS } from '@/constants/reactQueryKeys'

const Statistical: React.FC<IPermissionProps> = () => {
    const { employee } = useAuthStore()
    const { t } = useTranslation('business')
    const { data, renderState } = useQueryWithHandler({
        queryKey: [QUERY_KEYS.BUSINESS_SUMMARY, employee?.employee_id],
        queryFn: async () => {
            const result = await getBusinessSummary()
            return result
        },
    })
    const stateComponent = renderState()
    if (stateComponent) return stateComponent
    const summaryItems: {
        key: keyof BusinessSummary
        label: string
        icon: React.ReactNode
    }[] = [
        {
            key: 'approved_total',
            label: t('business-approved-total'),
            icon: <ApprovedIcons />,
        },
        {
            key: 'pending_total',
            label: t('business-pending-total'),
            icon: <PendingIcons />,
        },
        {
            key: 'rejected_total',
            label: t('business-rejected-total'),
            icon: <RejectedIcons />,
        },
    ]
    return (
        <div className="grid lg:grid-cols-3 grid-cols-1 gap-2 mt-2">
            {summaryItems.map(({ key, label, icon }) => (
                <div key={key} className="p-4 bg-white rounded-md">
                    <Typogaphy size="medium" className="text-primary">
                        {label}
                    </Typogaphy>
                    <div className="flex items-center gap-2 mt-2">
                        {icon}
                        <span className="text-xl font-semibold">
                            {data?.result?.[key] ?? 0}
                        </span>
                    </div>
                </div>
            ))}
        </div>
    )
}

export default Statistical
